import React from 'react';

function Footer() {
    return (
        <footer className="bg-background-light dark:bg-background-dark border-t border-slate-200 dark:border-slate-800 py-12 text-center md:text-left">
            <div className="max-w-[1200px] mx-auto px-4 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
                <div className="flex items-center gap-3">

                    <span className="text-slate-600 dark:text-slate-400 text-sm">© 2026 Yavuz Selim Bostancı. All rights reserved.</span>
                </div>
                <div className="flex items-center gap-4">
                    <a className="text-slate-400 hover:text-sky-300 transition-colors" href="https://www.linkedin.com/in/yavuzselimbostanci" target="_blank" rel="noopener noreferrer">
                        <svg className="size-6" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path></svg>
                    </a>
                    <a className="text-slate-400 hover:text-sky-300 transition-colors" href="mailto:yavuz@yavuzbostanci.com">
                        <span className="material-symbols-outlined text-3xl">mail</span>
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
